import { faqItems } from '@/mocks/homeData';

export default function SectionFaq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">常见问题</h2>
          <p className="mt-3 text-sm text-foreground-600">关于色影视的使用，您可能想了解的问题都在这里</p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item) => (
            <details key={item.id} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{item.q}</h3>
                <div className="w-6 h-6 rounded-full bg-background-200 flex items-center justify-center flex-shrink-0 group-open:bg-primary-500 group-open:text-background-50 transition-colors">
                  <i className="ri-add-line text-sm group-open:hidden"></i>
                  <i className="ri-subtract-line text-sm hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}